module.exports = __webpack_public_path__ + "static/media/home-logo.7a9dd62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home-logo.png
// module id = 1247
// module chunks = 0